import { render, staticRenderFns } from "./UsuarioAuditoria.vue?vue&type=template&id=3200f20e&scoped=true"
import script from "./UsuarioAuditoria.vue?vue&type=script&lang=js"
export * from "./UsuarioAuditoria.vue?vue&type=script&lang=js"
import style0 from "./UsuarioAuditoria.vue?vue&type=style&index=0&id=3200f20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200f20e",
  null
  
)

export default component.exports